<template>
  <v-container>
    <h2>
      分析サンプル貼り付け用バーコードシートを印刷する
    </h2>
    <br>
    <div class="mb-3 body-2">
      分析サンプル貼り付け用バーコードシートとは、ジャパン・アナリストにサンプルを送付する際にサンプルボトルに貼り付けていただくためのQRコードです。<br>
      バーコードシートの印刷は下記の手順にて実施ください。
    </div>

    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-qrcode</v-icon>
          <span class="white--text body-1 font-weight-light">分析サンプル貼り付け用バーコードのメリット</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
          このQRコードを、それぞれのサンプルボトルに貼り付けていただくだけで、
          サンプルボトルに識別番号等を手書きしていた手間がなくなり、サンプル採取作業を効率化することができます。
        </v-card-text>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>マイページの表示</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      マイページを表示するために、画面上部の「メニュー」から、「マイページ」を選択します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-entry-confirm-01.png" width="80%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>申し込み履歴を開く</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      マイページ画面に分析依頼一覧リストの中から、印刷したいお申込みをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-confirm-02.png" width="95%" class="my-2">
    </div>

    <div class="ml-4 mt-4 body-2">
      申し込み履歴画面が開きます
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-entry-confirm-03.png" width="95%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>バーコードシートを確認する</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      画面上部の「貼り付け用バーコードシートを確認する」ボタンをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-sample-qr-print-01.png" width="95%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>バーコードシートを印刷する</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      「バーコード」画面が開きます。上部の「バーコードシートを印刷する」ボタンをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-sample-qr-print-02.png" width="95%" class="my-2">
    </div>

    <div class="ml-4 mt-4 body-2">
      バーコードシートのプリントプレビュー画面が開きます。用紙サイズをA4に設定し、「印刷」ボタンをクリックすることで印刷します。<br>
      印刷するプリンタに24カットシール紙をセットして印刷してください。バーコードシートは24カットシール紙に最適化されています。

    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-sample-qr-print-03.png" width="95%" class="my-2">
    </div>

    <div class="my-4">
      <h3>バーコード画面の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      バーコードシートの各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="printData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in printData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="my-4">
      <h3>サンプル情報の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      サンプル情報の各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="sampleData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sampleData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

</v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: '',
        printData: [
          {
            name: 'お申込日',
            body: 'お申込みいただいた日時です',
          },
          {
            name: 'サンプル数',
            body: 'お申込みいただいた分析サンプル数です。サンプルボトル数ではありません。',
          },
          {
            name: '受注番号',
            body: 'お申込みを受け付けた際に発行される番号です。お申込みを受け付ける前は「採番待ち」となります。',
          },
          {
            name: '分析依頼者',
            body: '請求書および納品明細書の送付先です。',
          },
          {
            name: 'バーコード情報',
            body: 'お申込みいただいたサンプルの内容です。サンプル情報の内容は別表にて説明します。',
          },
        ],
        sampleData: [
          {
            name: '企業名',
            body: '分析依頼者の企業名を表示します。シートに収まらない場合は省略します。',
          },
          {
            name: 'サンプル名',
            body: '分析サンプル名を表示します。シートに収まらない場合は省略します。',
          },
          {
            name: '採油日',
            body: 'サンプル採取登録を実施した日を表示します'
          },
          {
            name: 'Bottle',
            body: 'ご依頼いただいたサンプルのボトル数です。複数本ある場合は全数分を表示します。',
          },
          {
            name: 'サンプルQRコード',
            body: 'サンプルごとに一意に採番されたサンプル番号をバーコード化したものです。サンプルボトル1本目だけQRコードを表示します。',
          },
        ],

    }),
    methods: {
    }
}
</script>

